@if (showAsDialog) {
  <div class="modal-header">
    <h2 class="modal-title">Family Detail</h2>
  </div>
}

@if (familyInfo) {
  <div class="page-content page-fill">
    <div class="dx-toolbar mb-3">
      <h2 class="d-block ms-4">{{ familyInfo?.Name }}</h2>
    </div>
    <div class="d-flex">
      <dx-form [formData]="familyInfo" [colCount]="2" class="flex-fill" [readOnly]="showAsDialog">
        <dxi-item [itemType]="'group'" [colCount]="2">
          @if (!familyInfo.isHomePhoneUnlisted) {
            <dxi-item dataField="HomePhone" [label]="{ text: 'Phone' }"></dxi-item>
          }
          <dxi-item dataField="isHomePhoneUnlisted" [label]="{ text: 'Unlisted' }" editorType="dxCheckBox"></dxi-item>
          <dxi-item dataField="Address1" [colSpan]="2"></dxi-item>
          <dxi-item dataField="Address2" [colSpan]="2"></dxi-item>
          <dxi-item dataField="City"></dxi-item>
          <dxi-item
            dataField="State"
            [label]="{ text: 'State' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: states, valueExpr: 'text', displayExpr: 'text' }"
          ></dxi-item>
          <dxi-item dataField="Zip"></dxi-item>
          <dxi-item dataField="country"></dxi-item>
        </dxi-item>
        <dxi-item [itemType]="'group'">
          <dxi-item
            dataField="HouseholdId"
            [label]="{ text: 'Household' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: households, valueExpr: 'id', displayExpr: 'name' }"
            >
          </dxi-item>
        </dxi-item>
      </dx-form>
      @if (photoUrl) {
        <div class="ms-3" style="width: 300px">
          <img src="{{ photoUrl }}" class="w-100" />
        </div>
      }
    </div>
    <dx-tab-panel [items]="[{ title: 'Members', template: 'membersTemplate' }]" class="mt-3">
      <div *dxTemplate="let item of 'membersTemplate'">
        <div class="m-3">
          @if (family) {
            <dx-data-grid
              #familyPeopleGrid
              [dataSource]="family.members"
              keyExpr="Id"
              height="300px"
              [wordWrapEnabled]="true"
              (onToolbarPreparing)="onToolbarPreparing($event)"
              >
              <dxi-column dataField="FirstName"></dxi-column>
              <dxi-column dataField="LastName"></dxi-column>
              <dxi-column dataField="Relationship"></dxi-column>
              <dxi-column dataField="HomePhone"></dxi-column>
              <dxi-column dataField="CellPhone"></dxi-column>
              <dxi-column dataField="Birthday"></dxi-column>
              <dxi-column dataField="Email"></dxi-column>
              <!-- <dxi-column dataField="birthDateLocal" caption="Birthday" [sortIndex]="1" [sortOrder]="'asc'"></dxi-column> -->
              <!-- <dxi-column dataField="personStatus.name" caption="Person Status"></dxi-column> -->
              <div *dxTemplate="let data of 'toolbarButtons'"></div>
            </dx-data-grid>
          }
        </div>
      </div>
    </dx-tab-panel>
  </div>
}
@if (showAsDialog) {
  <div class="modal-footer">
    <button (click)="closeDialog()" class="btn btn-secondary">Close</button>
  </div>
}
